/*       */

import mustache from 'mustache';

import { DATETIME_FORMAT, DATE_FORMAT, TIME_FORMAT, formatDate } from 'app/utils/date/date';

// Хранилище для массивов, которые не должны превращаться в строки
const arrayResults = new Map();
let arrayCounter = 0;

mustache.escape = value => {
    if (value === null || value === undefined) {
        return '';
    }
    // Если это наш специальный маркер массива - не трогаем его
    if (typeof value === 'string' && value.startsWith('__ARRAY_MARKER_')) {
        return value;
    }
    if (typeof value === 'object') {
        return JSON.stringify(value);
    }
    return String(value);
};

const fixLegacyTemplate = (template = '') => {
    let updatedTemplate = template;
    (template.match(/\{\{([^{}]*)\}\}/g) || []).forEach(placeholder => {
        const token = placeholder.substring(2, placeholder.length - 2);
        if (token.includes(':')) {
            const [path, ...modifiers] = token.split(':');
            if (modifiers.length === 1) {
                const modifier = modifiers[0].toUpperCase();
                updatedTemplate = updatedTemplate.replaceAll(placeholder, `{{#fn.${modifier}}}{{${path}}}{{/fn.${modifier}}}`);
            } else if (modifiers.length > 1) {
                updatedTemplate = updatedTemplate.replaceAll(
                    placeholder,
                    modifiers.reduce((accum, modifierLower, indx) => {
                        const modifier = modifierLower.toUpperCase();
                        if (indx === 0) {
                            accum = `{{#fn.${modifier}}}{{${path}}}{{/fn.${modifier}}}`;
                        } else {
                            accum = `{{#fn.${modifier}}}${accum}{{/fn.${modifier}}}`;
                        }
                        return accum;
                    }, '')
                );
            }
        }
    });
    return updatedTemplate;
};

export const compile = (template = '') => {
    return fixLegacyTemplate(template);
};

// Функция для замены маркеров на реальные массивы
const replaceArrayMarkers = (obj) => {
    if (typeof obj === 'string' && obj.startsWith('__ARRAY_MARKER_')) {
        return arrayResults.get(obj) || obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(replaceArrayMarkers);
    }
    if (obj && typeof obj === 'object') {
        const result = {};
        for (const [key, value] of Object.entries(obj)) {
            result[key] = replaceArrayMarkers(value);
        }
        return result;
    }
    return obj;
};

export const render = (compiled, context) => {
    arrayResults.clear();
    arrayCounter = 0;
    
    const result = mustache.render(compiled, {
        ...context,
        fn: {
            UPPER: function() {
                return function(value, render) {
                    return value ? render(value).toUpperCase() : '';
                };
            },
            LOWER: function() {
                return function(value, render) {
                    return value ? render(value).toLowerCase() : '';
                };
            },
            CAPITAL: function() {
                return function(value, render) {
                    const text = render(value);
                    return text ? (text.length > 0 ? `${text[0].toUpperCase()}${text.substring(1)}` : text) : '';
                };
            },
            DATETIME: function() {
                return function(value, render) {
                    const text = render(value);
                    return text && formatDate(text, DATETIME_FORMAT);
                };
            },
            DATE: function() {
                return function(value, render) {
                    const text = render(value);
                    return text && formatDate(text, DATE_FORMAT);
                };
            },
            TIME: function() {
                return function(value, render) {
                    const text = render(value);
                    return text && formatDate(text, TIME_FORMAT);
                };
            },
            MAPTOID: function() {
                return function(value, render) {
                    try {
                        const data = JSON.parse(render(value));
                        if (Array.isArray(data)) {
                            const ids = data.map(item => item?.id).filter(Boolean);
                            const marker = `__ARRAY_MARKER_${arrayCounter++}`;
                            arrayResults.set(marker, ids);
                            return marker;
                        }
                    } catch (e) {}
                    return '[]';
                };
            },
        },
    });
    
    if (typeof result === 'string' && result.includes('__ARRAY_MARKER_')) {
        const marker = result.trim();
        return arrayResults.get(marker) || result;
    }
    
    return result;
};

// Экспортируем функцию для замены маркеров (используется в evaluateProperty)
export const resolveArrayMarkers = replaceArrayMarkers;
